import { IconPropsType } from '..';

export const RocketColoredIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.10923 12.5975L5.40248 10.8907V8.04615L9.95383 12.5975H7.10923Z"
        fill="#E2E3E4"
      />
      <path
        d="M16.2 1.79999C16.2 1.79999 11.0917 1.78804 7.10923 5.77047C5.40817 7.47154 5.40248 10.3218 6.54031 11.4597C7.67815 12.5975 10.5284 12.5918 12.2295 10.8907C16.2119 6.90831 16.2 1.79999 16.2 1.79999ZM10.2 6.33939C10.2 5.71074 11.0319 4.92176 11.6606 4.92176C12.2892 4.92176 13.0786 5.71074 13.0786 6.33939C13.0786 6.96805 12.2892 7.79999 11.6606 7.79999C11.0319 7.79999 10.2 6.96805 10.2 6.33939Z"
        fill="#E2E3E4"
      />
      <path
        d="M11.5531 10.7064C11.5531 10.7064 12.4144 13.0655 11.5531 13.9263C10.2616 15.2177 7.86315 16.2 7.86315 16.2L8.24707 11.4597L11.5531 10.7064Z"
        fill="currentColor"
      />
      <path
        d="M7.29356 6.44692C7.29356 6.44692 4.93445 5.47805 4.07367 6.33939C2.78223 7.63084 1.79999 10.1368 1.79999 10.1368L6.54031 9.75291L7.29356 6.44692Z"
        fill="currentColor"
      />
      <path
        d="M6.68868 13.0247C6.64775 13.0829 6.62319 13.1502 6.57044 13.202C5.68363 14.0884 4.35297 13.6456 4.35297 13.6456C4.35297 13.6456 3.90911 12.3156 4.79683 11.4293C4.84958 11.3765 4.91598 11.3529 4.97419 11.3111L4.55853 10.8947C4.2129 10.9856 3.88456 11.1584 3.61442 11.4284C2.37199 12.6702 2.56936 15.4284 2.56936 15.4284C2.56936 15.4284 5.31254 15.642 6.57135 14.3838C6.84148 14.1138 7.0143 13.7856 7.10525 13.4402L6.68868 13.0247Z"
        fill="currentColor"
      />
    </svg>
  );
};
